// extracted by mini-css-extract-plugin
export default {"skeleton":"V3xcmB","shine-lines":"X8dV4e"};